import { dark, light } from 'generated/design-tokens';

import { THEME_ALIASES, ThemeAlias } from './theme-consts';

export type { ThemeColor } from 'generated/design-tokens';

export const themeColors = {
  [THEME_ALIASES.LIGHT]: light,
  [THEME_ALIASES.DARK]: dark,
} as const;

export const isThemeSupported = (theme: string | undefined | null): theme is ThemeAlias => {
  return !!theme && Object.values(THEME_ALIASES).includes(theme as ThemeAlias);
};

export const resolveTheme = (
  theme: ThemeAlias,
): typeof THEME_ALIASES.DARK | typeof THEME_ALIASES.LIGHT => {
  if (theme !== THEME_ALIASES.BROWSER) {
    return theme;
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches
    ? THEME_ALIASES.DARK
    : THEME_ALIASES.LIGHT;
};
